import React, { useEffect, useRef } from "react";


export function FileLink({ fileUrl, fileName, fileContentType, ...otherProps }) {
  const innerRef = useRef(null);

  useEffect(() => {
    const link = innerRef.current;
    const onDragstart = function (e) {
      if (this.dataset) {
        e.dataTransfer.setData('DownloadURL', this.dataset.downloadurl);
      }
    }
    link.addEventListener('dragstart', onDragstart, false);
    return () => {
      link.removeEventListener('dragstart', onDragstart);
    };
  }, []);

  return (
    <a
      href={fileUrl}
      target={'_blank'}
      data-downloadurl={`${fileContentType}:${fileName}:${fileUrl}`}
      ref={innerRef}
      rel={'noreferrer'}
      {...otherProps}
    >
      {fileName}
    </a>
  )
}
